define('views/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/animated-session/animation/rename/form/animation-rename-form',
    // templates
    'text!templates/modules/calendar/animated-session/animation/rename/edit/custom-name-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    // views
    VMenuSaveAction,
    VCustomNameForm,
    // templates
    TCustomNameEditContent
) {

    var VCustomNameEditContent = Backbone.View.extend({

        template: TCustomNameEditContent,

        regions: {
            root: ".custom-name-edit-content",
            menu: ".menu-actions",
            form: ".custom-name-edit-form",
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = this.options.group;

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSave,
                    saveText: "Save",
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VCustomNameForm({
                    model: this.model,
                })
            };

            this.listenTo(view.form, {
                'model:change': this.onModelChange,
                'form:success': this.onSuccess
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        toggleSaveButton: function(val) {

        },

        onModelChange: function() {
            var view = this.view;
            view.menu.toggleSaveButton(!view.form.isDirty());
        },

        onSave: function() {
            this.view.form.submit();
        },

        onSuccess: function() {
            this.trigger('form:success');
        },

    });

    return VCustomNameEditContent;

});

